import _ from 'lodash'
import {
    USERS_READ_FROM_FORAGE,
    USERS_FORGET_USERS,
    USERS_LOGIN_USER,
    USERS_LOGOUT_USER,
    USERS_SET_USER_PINNED_STATE,
    USERS_SET_USER_MULTILAUNCH_STATE,
    USERS_SET_USER_ACCESSTOKEN,
    USERS_SET_USER_PROFILE,
    USERS_SET_AUTOLAUNCH,
    USER_SET_ORDER,
} from '../constants'

// Initial state for users in the store
const usersInitialState = {
    order: {
        tq: [],
        sisi: [],
    },
    list: {
        tq: {},
        sisi: {},
    },
}

export default function users(state = usersInitialState, action) {
    const clone = _.cloneDeep(state)
    switch (action.type) {
        // Read the users from forage
        case USERS_READ_FROM_FORAGE:
            return action.payload

        // Remove users from the store
        case USERS_FORGET_USERS:
            return _.cloneDeep(usersInitialState)

        case USER_SET_ORDER: {
            const { server, order } = action.payload

            clone.order[server] = _.uniq(order)

            return clone
        }

        // Add user to the list of users (replace if already included)
        case USERS_LOGIN_USER: {
            const { server, user } = action.payload

            // If the server is missing from users, add it
            if (clone.list[server] == null) {
                clone.list[server] = {}
            }

            // If the server is missing from order list, add it
            if (clone.order[server] == null) {
                clone.order[server] = []
            }

            // If user was already in state, take a look at the profile...
            let storedProfile = ''
            if (
                clone.list[server][user.username] != null &&
                clone.list[server][user.username].shell
            ) {
                storedProfile = clone.list[server][user.username].profile
            }

            // Add/replace user in list
            clone.list[server][user.username] = user

            // Use the stored profile state if it existed
            if (storedProfile !== '') {
                clone.list[server][user.username].profile = storedProfile
            }

            // Add user to order list
            if (clone.order[server].indexOf(user.username) === -1) {
                clone.order[server].push(user.username)
            }

            return clone
        }

        // Remove user from list of users (if included)
        case USERS_LOGOUT_USER: {
            const { server, userKey } = action.payload
            if (
                clone == null ||
                clone.list == null ||
                clone.list[server] == null ||
                clone.list[server][userKey] == null
            ) {
                return state
            }

            // If profile was other than 'Default', we don't want to remove it completely
            if (clone.list[server][userKey].profile !== 'Default') {
                clone.list[server][userKey] = {
                    username: userKey,
                    profile: clone.list[server][userKey].profile,
                    shell: true,
                }
            } else {
                clone.list[server] = _.omit(clone.list[server], userKey)
            }

            // Remove user from order list
            clone.order[server].splice(clone.order[server].indexOf(userKey), 1)

            return clone
        }

        // Toggle whether the given user is remembered or not (if found)
        case USERS_SET_USER_PINNED_STATE: {
            const { server, userKey, pinned } = action.payload
            if (
                clone == null ||
                clone.list == null ||
                clone.list[server] == null ||
                clone.list[server][userKey] == null
            ) {
                return state
            }
            clone.list[server][userKey].remember = pinned
            return clone
        }

        // Toggle whether the given user is part of multi-launch or not
        case USERS_SET_USER_MULTILAUNCH_STATE: {
            const { server, userKey, multiLaunch } = action.payload
            if (
                clone == null ||
                clone.list == null ||
                clone.list[server] == null ||
                clone.list[server][userKey] == null
            ) {
                return state
            }
            clone.list[server][userKey].multiLaunch = multiLaunch
            return clone
        }

        // Toggle whether the given user is set to autolaunch
        case USERS_SET_AUTOLAUNCH: {
            const { server, userKey, autoLaunch } = action.payload
            if (
                clone == null ||
                clone.list == null ||
                clone.list[server] == null ||
                clone.list[server][userKey] == null
            ) {
                return state
            }
            clone.list[server][userKey].autoLaunch = autoLaunch
            return clone
        }

        // Update the accessToken of the given user (if found)
        case USERS_SET_USER_ACCESSTOKEN: {
            const { server, userKey, accessToken } = action.payload
            if (
                clone == null ||
                clone.list == null ||
                clone.list[server] == null ||
                clone.list[server][userKey] == null ||
                clone.list[server][userKey].tokens == null
            ) {
                return state
            }
            clone.list[server][userKey].tokens.accessToken = accessToken
            return clone
        }

        // Update the profile of the given user (if found)
        case USERS_SET_USER_PROFILE: {
            const { server, userKey, profile } = action.payload
            if (
                clone == null ||
                clone.list == null ||
                clone.list[server] == null ||
                clone.list[server][userKey] == null
            ) {
                return state
            }
            clone.list[server][userKey].profile = profile
            return clone
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/users.js